<div class="debug-itrent-position">
  <h2>Raw contract hours data</h2>
  <div class="row pb-2">
    <div class="col-2">
      <button type="button" class="btn btn-primary" (click)="getRawResponseForPosition()">Get position</button>
    </div>
    <div class="col">
      <input type="text" class="form-control" [(ngModel)]="positionId" placeholder="Enter position id">
    </div>
  </div>
  <div class="row pb-3">
    <div class="col">
      <textarea class="form-control" rows="5" [(ngModel)]="rawPositionResponse"></textarea>
    </div>
  </div>
</div>
